// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.autoname[data-v-5ffffb6f]{\n  height: 25px;\n  line-height: 25px;\n}\n.autoaddress[data-v-5ffffb6f]{\n  font-size: 12px;\n  color: #b4b4b4;\n}\n", ""]);
// Exports
module.exports = exports;
